export default function initQuantityInput() {
    const containers = document.querySelectorAll('.product-quantity');

    if (!containers.length) {
        return;
    }

    const fmt = (val) => val.toFixed(2).replace('.', ',') + ' \u20AC';

    containers.forEach((container) => {
        const input = container.querySelector('.product-quantity-input');
        const minusBtn = container.querySelector('.product-quantity-btn--minus');
        const plusBtn = container.querySelector('.product-quantity-btn--plus');

        if (!input || !minusBtn || !plusBtn) {
            return;
        }

        const wrapper = container.closest('.product-hero, .product-card');

        if (!wrapper) {
            return;
        }

        const updatePrice = (qty) => {
            const unitPrice = parseFloat(container.dataset.unitPrice) || 0;
            const priceBlock = wrapper.querySelector('.product-hero-price, .product-card-price');

            if (!priceBlock || !unitPrice) {
                return;
            }

            const regularPrice = parseFloat(priceBlock.dataset.regularPrice) || 0;
            const total = unitPrice * qty;

            const setAmount = (el, val) => {
                if (!el) {
                    return;
                }
                const html = fmt(val);
                const bdi = el.querySelector('bdi');
                if (bdi) {
                    bdi.innerHTML = html;
                } else {
                    el.innerHTML = html;
                }
            };

            const saleEl = priceBlock.querySelector('.product-hero-price-sale .woocommerce-Price-amount, .product-card-price-sale .woocommerce-Price-amount');
            if (saleEl) {
                setAmount(saleEl, total);
            } else {
                setAmount(
                    priceBlock.querySelector('.product-hero-price-current .woocommerce-Price-amount, .product-card-price-current .woocommerce-Price-amount'),
                    total
                );
            }

            if (regularPrice > 0) {
                setAmount(
                    priceBlock.querySelector('.product-hero-price-original .woocommerce-Price-amount, .product-card-price-original .woocommerce-Price-amount'),
                    regularPrice * qty
                );
            }
        };

        const syncHidden = (qty) => {
            const form = container.closest('form') || wrapper.querySelector('form.cart, .product-card-add-to-cart');

            if (form) {
                const hidden = form.querySelector('.product-hero-qty-hidden, .product-card-qty-hidden');

                if (hidden) {
                    hidden.value = qty;
                }
            }
        };

        const setQuantity = (val) => {
            val = Math.max(1, parseInt(val, 10) || 1);
            input.value = val;
            updatePrice(val);
            syncHidden(val);
        };

        const bump = (btn) => {
            btn.classList.add('bump');
            btn.addEventListener('animationend', () => {
                btn.classList.remove('bump');
            }, { once: true });
        };

        minusBtn.addEventListener('click', () => {
            setQuantity(parseInt(input.value, 10) - 1);
            bump(minusBtn);
        });

        plusBtn.addEventListener('click', () => {
            setQuantity(parseInt(input.value, 10) + 1);
            bump(plusBtn);
        });

        input.addEventListener('input', () => {
            setQuantity(input.value);
        });

        input.addEventListener('blur', () => {
            if (!input.value || parseInt(input.value, 10) < 1) {
                setQuantity(1);
            }
        });

        const form = container.closest('form') || wrapper.querySelector('form.cart, .product-card-add-to-cart');

        if (form) {
            form.addEventListener('submit', () => {
                setTimeout(() => setQuantity(1), 100);
            });
        }
    });
}